<template>
  <div class="home-block">
    <div class="container my-5 pb-5 signup">
      <div class="row align-items-center h-100">
        <div class="col-12 col-md-8">
          <div class="promo">
            <h3>
              {{ $t("doyouhave") }}
              <u ref="symtpom">{{ getSymtpom }}</u
              >?
            </h3>
            <h3>{{ $t("wecanhelp") }}</h3>
            <p class="text-muted">
              {{ $t("mainMessage") }}
            </p>
          </div>
          <form @submit.prevent="submitUsername" v-if="!authUser">
            <div class="myfield w-100 mb-4">
              <input
                type="text"
                id="identifier"
                v-model="identifier"
                autofocus
                @keyup.enter="submitUsername"
              />
              <label for="identifier">{{ $t("identifier") }}</label>
            </div>
            <button
              type="submit"
              class="btn btn-block my-btn p-3 svg"
              @click="submitUsername"
              :disabled="!identifier"
            >
              {{ $t("next") }}
              <DoubleArrow></DoubleArrow>
            </button>
          </form>
          <div class="my-1">
            <Or v-if="!authUser"></Or>
          </div>
          <CheckSymptoms></CheckSymptoms>
          <div class="my-1">
            <Or v-if="!authUser"></Or>
          </div>
          <CovidChecker></CovidChecker>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DoubleArrow from '@/components/Icons/DoubleArrow'
import CheckSymptoms from '@/components/CheckSymptoms'
import CovidChecker from '@/components/CovidChecker'
import Or from '@/components/Or'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    DoubleArrow,
    CheckSymptoms,
    CovidChecker,
    Or
  },
  data () {
    return {
      identifier: null,
      symtpom: 'headache',
      symptoms: ['headache', 'stomachache', 'fever'],
      current: 0
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      authUser: 'auth/user'
    }),
    getSymtpom () {
      return this.$t(this.symtpom)
    }
  },
  mounted () {
    const ref = this.$refs.symtpom
    setInterval(() => {
      ref.classList.add('slideout')
      ref.classList.remove('slidein')
      setTimeout(() => {
        ref.classList.add('slidein')
        ref.classList.remove('slideout')
        this.symtpom = this.symptoms[this.current]
        this.current++
        if (this.current === this.symptoms.length) {
          this.current = 0
        }
      }, 500)
    }, 3000)
  },
  methods: {
    ...mapActions({
      interviewInit: 'interview/init'
    }),
    submitUsername () {
      this.$router.push({ name: 'Login', query: { identifier: this.identifier } })
      return null
    }
  }
}
</script>
<style lang="scss">
.home-block {
  // .signup {
  // min-height: 60vh;
  // }
  .promo {
    h3 {
      position: relative;
      overflow: hidden;
      u {
        display: inline-block;
        text-decoration: underline;
        &.change {
          animation-name: slidein;
          animation-duration: 1s;
        }
        &.slidein {
          animation-name: slidein;
          animation-duration: 0.5s;
        }
        &.slideout {
          animation-name: slideout;
          animation-duration: 0.5s;
        }
      }
    }
  }
}
@keyframes change {
  0% {
    opacity: 1;
    transform: translateY(0%);
  }
  10% {
    opacity: 0;
    transform: translateY(100%);
  }
  90% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}
@keyframes slidein {
  0% {
    opacity: 0;
    transform: translateY(-100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}
@keyframes slideout {
  0% {
    opacity: 1;
    transform: translateY(0%);
  }
  100% {
    opacity: 0;
    transform: translateY(100%);
  }
}
</style>
<i18n>
{
  "ka": {
    "doyouhave": "გაწუხებს",
    "wecanhelp": "ჩვენ დაგეხმარებით",
    "mainMessage": "MYDOC მზად არის გახდეს „დისტანციური ხიდი“ პაციენტსა და ექიმს შორის ურთიერთობაში",
    "id_number": "პირადი ნომერი",
    "identifier": "მომხმარებლის სახელი",
    "next": "შემდეგი",
    "headache": "თავის ტკივილი",
    "stomachache": "მუცლის ტკივილი",
    "fever": "გაზრდილი ტემპერატურა",
    "checkyoursymptoms": "გადაამოწმე სიმპტომები AI-ს დახმარებით"
  },
  "en": {
    "doyouhave": "Do you have",
    "wecanhelp": "We can help",
    "identifier": "username",
    "mainMessage": "MYDOC is ready to become \"remote bridge\" between patient and doctor",
    "id_number": "ID",
    "next": "Next",
    "headache": "Headache",
    "stomachache": "Stomachache",
    "fever": "Fever",
    "checkyoursymptoms": "Check your symptoms using AI"
  }
}
</i18n>
